import KineduAuth from 'kinedu-auth';
import EventReporter from 'appEvents';
import i18n from 'i18next';

import { AppEvents, EventProviders } from 'constants/events';
import { IS_LOCALHOST, ENV, CLIENT_API_URL } from 'config';
import { APP_SECTIONS_PATHS } from 'constants/routes';
import { LOCAL_ACCOUNT_TOKEN, LOCAL_ACTIVE_CENTER_TOKEN, LOCAL_AUTH_TOKEN, LOCAL_USER_EMAIL } from '../constants/localStorage';
import { KEYS_LOCALSTORAGE } from 'constants/general';

const { API } = KineduAuth;
const { logout } = API(ENV, CLIENT_API_URL);

export const TIMEOUT = 30000;
export const TIMEOUT_MAX = 150000; // 2.5 Min
export const DEFAULT_HEADERS = { 'Content-Type': 'application/json' };

export const localeFlag = (locale?: string) => `locale=${(locale || localStorage.getItem(KEYS_LOCALSTORAGE.USER_LOCALE) || i18n.language || localStorage.getItem('i18nextLng') || 'en').substring(0, 2)}`;
export const setParam = (name: string, value: any) => (value ? `&${name}=${value}` : '');
export const redirectToRoot = () => {
  if (!IS_LOCALHOST) {
    window.location.assign(window.location.origin);
  } else {
    window.location.assign(APP_SECTIONS_PATHS.SIGNIN);
  }
};
export const appLogout = () => {
  logout(String(LOCAL_AUTH_TOKEN()), String(LOCAL_USER_EMAIL()))
    .then(() => {
      EventReporter.action(AppEvents.LOG_OUT(),
        [EventProviders.KINEDU, EventProviders.MIXPANEL]);
    });
  localStorage.clear();
};
export const apiResponseInterceptor = (res: any) => res.data;

export const apiErrorInterceptor = (error: any) => {
  if (error.response) {
    switch (error.response.status) {
    case 401: {
      appLogout();
      redirectToRoot();
      console.error('UNAUTHORIZED', error.response.data);
      break;
    }
    case 422: console.error('UNPROCESSABLE_ENTITY', error.response.data);
      break;
    case 500: console.error('SERVER_ERROR', error.response.data);
      break;
    default:
      console.error(error.response.data);
    }
  }
  if (error.code === 'ECONNABORTED') {
    // toast.error(i18n.t('validations:RESPONSE_ERRORS.TIMEOUT'), { autoClose: 5000 });
  }
  return Promise.reject(error);
};

export const getScopeByRoleType = (roleType: string) => {
  switch (roleType) {
  case 'Owner': return 'orgOscope';
  case 'Admin': return 'orgOscope';
  case 'Director': return 'centerScope';
  case 'Teacher': return 'centerScope';
  default: return 'orgScope';
  }
};

export const getHeadersWithTokens = (isActiveCenter?: boolean, _centerToken?: string) => {
  const centerToken = _centerToken || LOCAL_ACTIVE_CENTER_TOKEN();
  const token = isActiveCenter ? centerToken : LOCAL_ACCOUNT_TOKEN();

  const headers = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-User-Token': LOCAL_AUTH_TOKEN(),
      'X-User-Email': LOCAL_USER_EMAIL(),
    }
  };
  return headers;
};

export const setHeadersWithOrgToken = (token: string) => {
  const headers = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-User-Token': LOCAL_AUTH_TOKEN(),
      'X-User-Email': LOCAL_USER_EMAIL(),
    },
  };
  return headers;
};

export const apiRequestInterceptor = (config: any) => config;
